import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError, tap, finalize } from 'rxjs/operators';
import { Md5 } from 'ts-md5';
import { NbGlobalPhysicalPosition, NbGlobalPosition, NbIconConfig, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'environments/environment';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

    count = 0;

    constructor(public toasterService: NbToastrService, public router: Router,private modalService: NgbModal) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let token: string = sessionStorage.getItem('switchRoleJWTtoken') ? sessionStorage.getItem('switchRoleJWTtoken') : sessionStorage.getItem('jwtToken');

        /* if(request.body.password!=null) {
            request.body.password = Md5.hashStr(request.body.password);
        } */

        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
        }

        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        //request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        if(request.url != `${environment.APIendpoint}/ApplicativiRest/rest/ricerca-terza-missione/cambiaStatoNotificheProgetti` && request.url != `${environment.APIendpoint}/ApplicativiRest/rest/ricerca-terza-missione/listAllNotificheProgettiByUserDestinatarioPaged?pageNumber=1&pageMaxElement=10`){
            document.getElementById('nb-global-spinner-mini').style.display = 'flex';
        }
        

        this.count++;

        return next.handle(request)

            .pipe(

                tap(

                    event => {

                        if (event instanceof HttpResponse) {
                            
                            if (event.body && event.body.errorCode == 99) {

                                this.toasterService.danger(event.body.errorMessage, 'ATTENZIONE', {
                                    duration : 10000,
                                    destroyByClick : true,
                                    preventDuplicates : true,
                                    position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
                                });

                            }

                        }
                        
                        return event;
                    },

                    error => {

                        if (error.status != 999) {

                            let errorMessage = 'C\'è stato un errore server durante la richiesta effettuata.'
                                            +' Si prega di riprovare più tardi e se il problema dovesse persistere'
                                            +' contattare l\'amministratore di sistema.';

                            if (error.status == 401) {
                                errorMessage = "Sessione scaduta. Effettuare nuovamente l'accesso.";
                            }

                            document.getElementById('nb-global-spinner-mini').style.display = 'none';
                            document.getElementById('nb-global-error').style.display = 'flex';

                            // const iconConfig: NbIconConfig = { icon: iconName, pack: 'eva' };

                            this.toasterService.danger(errorMessage, 'ATTENZIONE', {
                                duration : 120000,
                                destroyByClick : true,
                                preventDuplicates : true,
                                position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
                            });

                            if (error.status == 401) {
                                setTimeout( () => this.logout(), 3000);
                            }

                        }

                        return error;

                    },

                ),

                finalize(() => {

                    this.count--;

                    if ( this.count == 0 ) {
                        // console.log("Nascondi Spinner")
                        document.getElementById('nb-global-spinner-mini').style.display = 'none';
                    }
                }),

            );
    }

    logout() {
        this.modalService.dismissAll();
        this.router.navigate(['/auth/logout']);
    }

}
 